import Spinner from "@legacy/core/components/Spinner";
import formatDuration from "@utils/formatDuration";
import { Component } from "react";
import { renderServiceLocationString } from "../../clients/utils/utils";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import DurationField from "../../core/fields/DurationField";
import GeneratedDatetimeField from "../../core/fields/GeneratedDatetimeField";
import TextField from "../../core/fields/TextField";
import { JobOriginTypes } from "../../core/utils/enums";
import AssignedTechniciansField from "../fields/AssignedTechniciansField";
import { getDefaultAssignedTechnicians, renderJobTime } from "../utils/utils";


class JobRescheduleForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const {job, rescheduleData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, workingTechnicianOptions, returnScroll} = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="primary" text="Reschedule" handler={event => requestAction("JOB_RESCHEDULE_SUBMIT")} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const {job, rescheduleData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, workingTechnicianOptions, returnScroll} = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Job Reschedule">
                    <div className="data-panel__form" aria-label="Job Reschedule Form">
                        <p className="data-panel__form__caption">Please provide some additional details to reschedule this job.</p>
                        <BasicDisplayField
                            fieldName="id"
                            fieldLabel="Roopairs Job ID"
                            fieldValue={job.custom_id ? job.custom_id : job.id}
                        ></BasicDisplayField>
                        {
                            job.origin_type !== JobOriginTypes.roopairs && (
                                <BasicDisplayField
                                    fieldName="origin_id"
                                    fieldLabel={`${job.origin_type_label} ID`}
                                    fieldValue={job.origin_id}
                                ></BasicDisplayField>
                            )
                        }
                        <BasicDisplayField
                            fieldName="service_name"
                            fieldLabel="Service Type"
                            fieldValue={job.service_name}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="is_job_walk"
                            fieldLabel="Job Type"
                            fieldValue={job.is_recall ? "Recall" : job.is_job_walk ? "Job Walk" : "Service"}
                        ></BasicDisplayField>

                        <BasicDisplayField
                            fieldName="service_location"
                            fieldLabel="Service Location"
                            fieldValue={renderServiceLocationString(job.service_location, true)}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="start_time"
                            fieldLabel="Estimated Arrival Time"
                            fieldValue={renderJobTime(job.start_time, job.service_company.preferred_timezone)}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="duration"
                            fieldLabel="Estimated Job Duration"
                            fieldValue={formatDuration(job.duration)}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="total_time_logged"
                            fieldLabel="Total Time Logged"
                            fieldValue={formatDuration(job.total_time_logged)}
                        ></BasicDisplayField>

                        <TextField
                            fieldName="details"
                            fieldLabel={job.is_recall ? "Reason For Recall" : "Reason For Call"}
                            fieldValue={rescheduleData.details || ""}
                            fieldOnChange={details => onFormDataChange("details", details || "")}
                            rows={3}
                            placeholder="Customer states..."
                            errors={errors}
                        ></TextField>
                        <TextField
                            fieldName="technician_instructions"
                            fieldLabel="Technician Instructions"
                            fieldValue={rescheduleData.technician_instructions || ""}
                            fieldOnChange={technician_instructions => onFormDataChange("technician_instructions", technician_instructions || "")}
                            rows={3}
                            placeholder={`Notes specific to this ${job.is_job_walk ? "job walk" : "service"}. e.g. 'Ask client about replacing the unit.' or 'Make sure to collect payment on site.'`}
                            optional={true}
                            errors={errors}
                        ></TextField>
                        <GeneratedDatetimeField
                            fieldName="start_time"
                            fieldLabel="New Estimated Arrival Time"
                            fieldValue={rescheduleData.start_time}
                            fieldOnChange={start_time => onFormDataChange("start_time", start_time || null)}
                            errors={errors}
                            preferredTimezone={job.service_company.preferred_timezone}
                        ></GeneratedDatetimeField>
                        <DurationField
                            fieldName="duration"
                            fieldLabel="New Estimated Job Duration"
                            fieldValue={rescheduleData.duration || ""}
                            fieldOnChange={duration => onFormDataChange("duration", duration || null)}
                            unit="hours"
                            unitMultiplier={3600}
                            errors={errors}
                        ></DurationField>
                        <AssignedTechniciansField
                            fieldName="assigned_technicians"
                            fieldLabel="Assigned Technician(s)"
                            fieldValue={getDefaultAssignedTechnicians(rescheduleData, workingTechnicianOptions)}
                            fieldOnChange={assigned_technicians => onFormDataChange("assigned_technicians", assigned_technicians || [])}
                            choices={workingTechnicianOptions}
                            placeholder="Select technicians..."
                            noOptionsMessage="No Technicians Found"
                            errors={errors}
                        ></AssignedTechniciansField>
                        <TextField
                            fieldName="reschedule_message"
                            fieldLabel="Reschedule Reason"
                            fieldValue={rescheduleData.reschedule_message || ""}
                            fieldOnChange={reschedule_message => onFormDataChange("reschedule_message", reschedule_message || "")}
                            rows={3}
                            placeholder="Why does this job need to be rescheduled?"
                            errors={errors}
                        ></TextField>
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default JobRescheduleForm;
